<script lang="ts">
import Vue from 'vue';
import BaseModal from '@/components/ui/BaseModal.vue';
import AddBranchModal from '@/views/organizations/components/AddBranchModal.vue';
import AddRegionModal from '@/views/organizations/components/AddRegionModal.vue';
import modalMixin from '@/views/organizations/mixins/modalMixin';

export default Vue.extend({
  name: 'AddStructureModal',
  components: { AddBranchModal, AddRegionModal, BaseModal },
  mixins: [modalMixin],
  data() {
    return {
      showRegionalModal: false,
      showBranchModal: false,
    };
  },
  methods: {
    openRegionModal() {
      this.showRegionalModal = true;
      this.close();
    },
    closeRegionModal() {
      this.showRegionalModal = false;
      this.open();
    },
    openBranchModal() {
      this.showBranchModal = true;
      this.close();
    },
    closeBranchModal() {
      this.showBranchModal = false;
      this.open();
    },
    goCreateManagerPage() {
      if (this.$route.meta.parent && this.$route.name !== 'organizations.managers.edit') {
        return { name: this.$route.meta.parent + '.managers.create', params: this.$route.params };
      }

      return { name: 'organizations.managers.create', params: {
        organizationId: this.$store.getters.USER.organizationId
      }
      };
    }
  }
});
</script>

<template>
<div>
    <AddBranchModal v-model="showBranchModal" @update="closeBranchModal" @saved="$emit('saved')"/>
    <AddRegionModal v-model="showRegionalModal" @update="closeRegionModal" @saved="$emit('saved')"/>
    <BaseModal class="add-structure-modal-popup" v-model="visible">
        <div class="add-structure-modal">
            <div class="title">
                Додати новий елемент структури
            </div>
            <div class="description">
                Оберіть, що ви хочете додати до ієрархії: дирекцію, відділення або менеджера.
                Додані елементи зʼявляться у структурі після збереження.
            </div>
            <div class="buttons">
                <div class="add-structure-button" @click="openRegionModal">
                    Обласна дирекція
                    <div class="plus">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.33301 8H12.6663" stroke="#FB923C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8 3.3335V12.6668" stroke="#FB923C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div class="add-structure-button" @click="openBranchModal">
                    Відділення
                    <div class="plus">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.33301 8H12.6663" stroke="#FB923C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8 3.3335V12.6668" stroke="#FB923C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </div>
                <router-link :to="goCreateManagerPage()" class="add-structure-button">
                    Менеджер
                    <div class="plus">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.33301 8H12.6663" stroke="#FB923C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M8 3.3335V12.6668" stroke="#FB923C" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                </router-link>
            </div>
        </div>
    </BaseModal>
</div>
</template>

<style scoped lang="scss">
.add-structure-modal {
    .title {
        font-family: Geist,serif;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 28px;
        /* identical to box height, or 117% */
        text-align: center;

        color: #09090B;

        /* Inside auto layout */
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
        margin-bottom: 21px;
    }
    .description {
        font-family: Geist,serif;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        /* or 125% */
        text-align: center;

        color: #9E9E9E;
        /* Inside auto layout */
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
    }
    .buttons {
        /* Auto layout */
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0;
        gap: 8px;
        /* Inside auto layout */
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
        z-index: 1;
        margin-top: 40px;

        .add-structure-button {
            &:hover {
                text-decoration: underline;
            }
            /* Auto layout */
            cursor: pointer;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            padding: 24px;
            gap: 24px;

            background: #F6F6F9;
            border-radius: 8px;

            /* Inside auto layout */
            flex: none;
            order: 0;
            flex-grow: 1;

            font-family: Geist,serif;
            font-style: normal;
            font-weight: 600;
            font-size: 20px;
            line-height: 120%;

            color: #020617;

            /* Inside auto layout */
            flex: none;
            align-self: stretch;
            flex-grow: 0;
            width: 33.3333%;


            .plus {
                /* Frame 1000005955 */

                box-sizing: border-box;

                width: 40px;
                height: 40px;

                border: 1px solid #FB923C;
                border-radius: 100px;

                /* Inside auto layout */
                flex: none;
                order: 1;
                flex-grow: 0;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }
    }
}

@media (max-width: 900px) {
    .add-structure-modal {
        .buttons {
            flex-direction: column;
        }
    }

    .add-structure-modal-popup {
        ::v-deep .base-modal {
            height: auto;
            top: 50px;
        }
    }

    .add-structure-button {
        width: 100% !important;
    }
}

@media (max-width: 650px) {
    .add-structure-modal-popup {
        ::v-deep .base-modal {
            left: 2.5%;
            width: 95%;
            padding: 56px 20px 20px;
        }
    }
}
</style>
